import "./App.css";
import "./index.css";
import {
  Route,
  BrowserRouter as Router,
  Routes,
  useLocation,
  Navigate,
} from "react-router-dom";
import { PageContextProvider } from "./Context/PageContext";
import CreateForm from "./Components/Form/CreateForm";
import UserResponsePage from "./Pages/UserResponsePage";
import FormsPage from "./Pages/FormsPage";
import AddNewResponseTableView from "./Pages/AddNewResponseTableView";
import ListViewinForm from "./Components/ListViewinForm";
import FormCreate from "./Components/Form/FormCreate";
import Response from "./Components/Form/Response";
import DataView from "./Components/Form/DataView";
import { TabularView } from "./Components/Form/TabularView";
import FolderView from "./Components/Folder/FolderView";
import SingleFolderView from "./Components/Folder/SingleFolderView";
import SettingPage from "./Components/Settings/SettingPage";
import GeneralSetting from "./Components/Settings/GeneralSetting";
import ResponseSetting from "./Components/Settings/ResponseSetting";
import Presenction from "./Components/Settings/Presenction";
import ThankYouSetting from "./Components/Settings/ThankYouSetting";
import EmailSetting from "./Components/Settings/EmailSetting";
import ViewScore from "./Components/Form/ViewScore";
import ThanksComponent from "./Components/Form/ThanksComponent";
import Topbar from "./Topbar";
import Sidebar from "./Sidebar";
import LandingPage from "./Pages/LandingPage";
import Register from "./Pages/Auth/Register";
import Login from "./Pages/Auth/Login";
import PrivateRoute from "./Pages/Auth/PrivateRoute";
import { useAuth } from "./Context/AuthContext";
import ComingSoon from "./Pages/ComingSoon";

function PublicRoute({ children }) {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? <Navigate to="/forms/list" /> : children;
}

function App() {
  const { isAuthenticated } = useAuth();
  const locationUrl = useLocation();

  const hideLayoutRoutes = ["/sign-in", "/sign-up", "/api", "/thankspage"];
  const isUserResponsePage = locationUrl.pathname.startsWith("/api");
  const shouldHideLayout = hideLayoutRoutes.some((route) =>
    locationUrl.pathname.startsWith(route)
  );

  const token = localStorage.getItem("token");

  const getContainerClass = () => {
    if (isUserResponsePage) {
      return "";
    }
    return token ? "app-container" : "app-container-landing";
  };

  return (
    <PageContextProvider>
      <>
        {isAuthenticated && !shouldHideLayout && (
          <>
            <Sidebar />
            <Topbar />
          </>
        )}

        <div className={getContainerClass()}>
          <Routes>
            <Route
              path="/register"
              element={
                // <PrivateRoute>
                <ComingSoon />
                // </PrivateRoute>
              }
            />
            <Route
              path="/"
              element={
                <PublicRoute>
                  <LandingPage />
                </PublicRoute>
              }
            />
            <Route
              path="/sign-up"
              element={
                <PublicRoute>
                  <Register />
                </PublicRoute>
              }
            />
            <Route
              path="/sign-in"
              element={
                <PublicRoute>
                  <Login />
                </PublicRoute>
              }
            />

            {/* Protected routes remain unchanged */}
            <Route
              path="/forms"
              element={
                <PrivateRoute>
                  <FormsPage />
                </PrivateRoute>
              }
            >
              <Route
                path="/forms/folder"
                element={
                  <PrivateRoute>
                    <FolderView />
                  </PrivateRoute>
                }
              />
              <Route
                path="/forms/list"
                element={
                  <PrivateRoute>
                    <ListViewinForm />
                  </PrivateRoute>
                }
              />
              <Route
                path="/forms/folder/:folderId"
                element={
                  <PrivateRoute>
                    <SingleFolderView />
                  </PrivateRoute>
                }
              />
            </Route>
            <Route
              path="/create-form"
              element={
                <PrivateRoute>
                  <CreateForm />
                </PrivateRoute>
              }
            >
              <Route
                path="/create-form/:formId/question"
                element={
                  <PrivateRoute>
                    <FormCreate />
                  </PrivateRoute>
                }
              />
              <Route
                path="/create-form/:formId/responses"
                element={
                  <PrivateRoute>
                    <Response />
                  </PrivateRoute>
                }
              >
                <Route
                  path="/create-form/:formId/responses/dataview"
                  element={
                    <PrivateRoute>
                      <DataView />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/create-form/:formId/responses/tableview"
                  element={
                    <PrivateRoute>
                      <TabularView />
                    </PrivateRoute>
                  }
                />
              </Route>
              <Route
                path="/create-form/:formId/settings"
                element={
                  <PrivateRoute>
                    <SettingPage />
                  </PrivateRoute>
                }
              >
                <Route
                  path="/create-form/:formId/settings/generalsetting"
                  element={
                    <PrivateRoute>
                      <GeneralSetting />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/create-form/:formId/settings/Responsesetting"
                  element={
                    <PrivateRoute>
                      <ResponseSetting />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/create-form/:formId/settings/Presentation"
                  element={
                    <PrivateRoute>
                      <Presenction />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="thanksPage"
                  element={
                    <PrivateRoute>
                      <ThankYouSetting />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="emailsetting"
                  element={
                    <PrivateRoute>
                      <EmailSetting />
                    </PrivateRoute>
                  }
                />
              </Route>
            </Route>
            <Route
              path="/api/:formId"
              element={
                <PrivateRoute>
                  <UserResponsePage />
                </PrivateRoute>
              }
            />
            <Route
              path="/create-form/:formId/responses/tableview/addResponse"
              element={
                <PrivateRoute>
                  <AddNewResponseTableView />
                </PrivateRoute>
              }
            />
            <Route
              path="/create-form/:formId/responses/tableview/addResponse/:insertOrder"
              element={
                <PrivateRoute>
                  <AddNewResponseTableView />
                </PrivateRoute>
              }
            />
            <Route
              path="/view-score/:formId/:userId"
              element={
                <PrivateRoute>
                  <ViewScore />
                </PrivateRoute>
              }
            />
            <Route
              path="/thankspage/:formId/:userId"
              element={
                <PrivateRoute>
                  <ThanksComponent />
                </PrivateRoute>
              }
            />
          </Routes>
        </div>
      </>
    </PageContextProvider>
  );
}

export default App;
